$( document ).ready(function() {
  $(document).on('change', '.js-change-banner-type', function(e) {
    $('.js-input-banner').hide();
    $('.js-banner-'+ $(this).val()).show();
  });
});
